module.exports = __webpack_public_path__ + "img/living_3_tn.26c76484.jpg";